export default __webpack_public_path__ + "static/media/factory__45.53105c6d.jpg";